<template>
  <div>
    <b-card header-tag="header">
      <template #header>
        <h4><i class="fas fa-clipboard" />&nbsp;Suivi technique</h4>
      </template>
      <b-row>
        <template v-for="softTenant in softTenants">
          <CardView
            :key="softTenant._source.reference"
            :softTenant="softTenant"
            :index="selectedTenant.index"
            collection="alarm-history"
          />
        </template>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import CardView from './CardView.vue';
import { mapGetters } from 'vuex';

export default {
  components: { CardView },
  name: 'TechnicalAlarm',
  computed: {
    ...mapGetters('tenants', [
      'selectedTenant',
      'selectedSoftTenant',
      'softTenants',
    ]),
  },
  data() {
    return {
      show: false,
      color: 'green',
    };
  },
};
</script>

<style lang="sass">
.logo
  width: 50%
</style>
